import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";

function App() {
  return (
    <>
      {/* <ScrollToTop /> */}
      {/* <Header /> */}
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
